import React from "react";
import PatientModuleHeader from "../layout/PatientModuleHeader";

export default function ConsultationPageHeader({
    idPatient,
    patientName,
    pages,
    handleSidebarToggle,
}) {
    return (
        <PatientModuleHeader
            pages={pages}
            onToggleSidebar={handleSidebarToggle}
            mobileBackTo={`/patients/${idPatient}`}
            mobileBackLabel="Paciente"
            mobileTitle={patientName || "Paciente"}
        />
    );
}
